export const DEAL_SETTINGS = {
  // Number of positive votes required for a deal to be considered "HOT"
  hotThreshold: 10,
  
  // Time window in hours for "NEW" deals
  newTimeWindow: 4
};